const SPACE_STEP_IN_EM = 0.25;

// Custom properties are invalid in container query conditions.
export function getPreviewContainerBreakpoint(steps: number) {
  return `${steps * SPACE_STEP_IN_EM}em`;
}
